import { Serializable } from '@/models/core/serializable';
import { GEnum } from '@/constants/enum.defination';
import { QuestionType } from '@/models/evalSetting/question-type';
import { CompetencyType } from '@/constants/competencyType.enum';
export class Competency implements Serializable<Competency> {
  competencyID: number;
  name: string;
  competencyType: GEnum.CompetencyType;
  questionCount: number; // 設問数
  isValid: boolean; //設問タイプに対する有効フラグ

  // UI パラメータ
  selected: boolean;

  deserialize(input: any) {
    this.competencyID = input.competencyID;
    this.name = input.name;
    this.competencyType = input.competencyType;
    this.isValid = input.isValid;
    this.questionCount = this.questionCount;
    return this;
  }

  get isCognitive(): boolean {
    return this.competencyType == GEnum.CompetencyType.Cognitive;
  }
  get isSelf(): boolean {
    return this.competencyType == GEnum.CompetencyType.Self;
  }
  get isGift(): boolean {
    return this.competencyType == GEnum.CompetencyType.Gift;
  }
  get isCommunity(): boolean {
    return this.competencyType == GEnum.CompetencyType.Community;
  }

  get bgColorClass(): string {
    return CompetencyType.bgColorClass(this.competencyType);
  }

  get colorCode(): string {
    return CompetencyType.colorCode(this.competencyType);
  }

  get bgCompetencyClass(): string {
    return CompetencyType.competencyBgColorClass(this.competencyType);
  }
}

export class CompetencySelection {
  competencyType: GEnum.CompetencyType;
  isCheckAll: boolean;
  indeterminate: boolean; //全選択表示制御
  checkAllGroup: number[];

  constructor(type: GEnum.CompetencyType) {
    this.competencyType = type;
    this.isCheckAll = false;
    this.indeterminate = false;
    this.checkAllGroup = [];
  }

  setCheckGroup(data: number[]) {
    this.checkAllGroup = data;
  }

  handleCheckAll(data: Competency[]) {
    if (this.indeterminate) {
      this.isCheckAll = false;
    } else {
      this.isCheckAll = !this.isCheckAll;
    }
    this.indeterminate = false;

    if (this.isCheckAll) {
      this.checkAllGroup = data.filter(d => d.competencyType == this.competencyType && d.isValid).map(d => d.competencyID);
    } else {
      this.checkAllGroup = [];
    }
  }

  handleCheckAllGroupChange(data: Competency[]) {
    if (this.checkAllGroup.length === data.filter((competency: Competency) => competency.isValid).length) {
      this.indeterminate = false;
      this.isCheckAll = true;
    } else if (this.checkAllGroup.length > 0) {
      this.indeterminate = true;
      this.isCheckAll = false;
    } else {
      this.indeterminate = false;
      this.isCheckAll = false;
    }
  }
}

export class QuestionTypesWithCompetency {
  competencies: Competency[];
  questionType: QuestionType;

  deserialize(input: any) {
    if (input.competencies) {
      this.competencies = input.competencies.map((competency: Competency) => new Competency().deserialize(competency));
    }

    this.questionType = input.questionType;
    return this;
  }
}

export class CompetencySettingType {
  miniCompetencies: SettingType[];
  recommendCompetencies: SettingType[];
  uchidaCompetencies: SettingType[];

  deserialize(input: any) {
    if (input.miniCompetencies) {
      this.miniCompetencies = input.miniCompetencies.map((competencySettingType: SettingType) => new SettingType().deserialize(competencySettingType));
    }
    if (input.recommendCompetencies) {
      this.recommendCompetencies = input.recommendCompetencies.map((competencySettingType: SettingType) => new SettingType().deserialize(competencySettingType));
    }
    if (input.uchidaCompetencies) {
      this.uchidaCompetencies = input.uchidaCompetencies.map((competencySettingType: SettingType) => new SettingType().deserialize(competencySettingType));
    }

    return this;
  }
}

export class SettingType {
  competencyID: number;
  competencyType: number;
  name: string;
  questionCount: number;

  deserialize(input: any) {
    this.competencyID = input.competencyID;
    this.competencyType = input.competencyType;
    this.name = input.name;
    this.questionCount = input.questionCount;
    return this;
  }
}

export class CustomCompetency {
  id: number;
  name: string;
  competencies: number[];
  isValid: boolean;

  deserialize(input: any) {
    this.id = input.customCompetencyID;
    this.name = input.name;
    this.competencies = input.competencies;
    this.isValid = input.isValid;
    return this;
  }
}

export class CreateCustomCompetency {
  name: string;
  competencyIDs: number[];
}

export class UpdateCustomCompetency {
  id: number;
  name: string;
  competencyIDs: number[];
}

export class CustomCompetencyBoxplot {
  competencyIDs: number[];

  deserialize(input: any) {
    this.competencyIDs = input.competencies || [];
    return this;
  }
}

export class AddUpdateCustomCompetencyBoxplot {
  competencyIDs: number[];
}